import styles from "./AuditLog.module.css";

export function ChangeValue({ value, side }: { value: unknown; side?: "from" | "to" }) {
  const sideClass = side === "from" ? styles.valueFrom : side === "to" ? styles.valueTo : "";
  if (value === null || value === undefined || value === "") {
    return (
      <pre className={`${styles.value} ${sideClass}`}>
        <span className={styles.valueEmpty}>empty</span>
      </pre>
    );
  }
  const text = typeof value === "string" ? value : JSON.stringify(value, null, 2);
  return <pre className={`${styles.value} ${sideClass}`}>{text}</pre>;
}

export function FromTo({ field, from, to }: { field: string; from: unknown; to: unknown }) {
  return (
    <div className={styles.change}>
      <h4 className={styles.changeField}>{field}</h4>
      <div className={styles.fromTo}>
        <div className={styles.valueBlock}>
          <span className={styles.valueLabel}>From</span>
          <ChangeValue value={from} side="from" />
        </div>
        <div className={styles.valueBlock}>
          <span className={styles.valueLabel}>To</span>
          <ChangeValue value={to} side="to" />
        </div>
      </div>
    </div>
  );
}
